/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with the key factory*/
import {
  keepPreviousData,
  useQuery,
  type UseQueryOptions
} from "@tanstack/react-query";

import { useAuth } from "~/providers/store/auth";

import { childrenKeys } from "../keys";
import { getChildren, type SearchChildrenRequest } from "../request";

export function useGetChildrenSearch(
  { search, groupName, fields }: SearchChildrenRequest["query"],
  { enabled }: Pick<UseQueryOptions, "enabled"> = { enabled: true }
) {
  const { tillId } = useAuth();
  const hasSearchQuery = Boolean(search?.length);

  return useQuery({
    queryKey: childrenKeys.search({ search, groupName, fields }),
    queryFn: () => {
      if (!tillId) throw new Error("Till ID is required");
      return getChildren(tillId, { search, groupName, fields });
    },
    enabled: hasSearchQuery && enabled,
    placeholderData: hasSearchQuery ? keepPreviousData : undefined
  });
}
